import PageData from "../PageData";
import {EventBus} from "../events/EventBus";
import {Section} from "../services/Section";
import AdFormService from "../services/AdFormService";
import {StickyContactButtonClickedEvent} from "../events/Events";
import {PageViewType} from "../types/PageViewType";

export default class ProperatiLamudiProjectPageStickyButtons {

    private readonly eventBus: EventBus;
    private readonly adFormService: AdFormService;

    constructor(pageData: PageData) {
        this.adFormService = new AdFormService();
        this.eventBus = EventBus.getInstance();
        document.querySelectorAll(".js-request-sticky").forEach(button => {
            this.configureSticky(pageData, button);
        });
    }

    private configureSticky(pageData: PageData, button: Element) {
        const projectId: string = pageData.id;

        let isProject: boolean = true;
        const section: Section = Section.SECTION_ADPAGE_STICKY_BOTTOM_CONTACT_FORM;
        if (pageData.pageViewType !== PageViewType.PROJECT_PAGE_DIRECTORY) {
            isProject = false;
        }

        button.addEventListener('click', (event) => {
            this.eventBus.emit(new StickyContactButtonClickedEvent({
                step: 2,
                section: section,
                pageViewId: pageData.pageViewId,
                propertyAdId: projectId,
                pageViewType: pageData.pageViewType,
            }));
        });

        this.adFormService.sendApplyImpression({
            pageViewId: pageData.pageViewId,
            propertyAdId: pageData.id,
            section: section,
            step: 1,
            isProject: isProject,
        });
    }

    static init(pageData: PageData) {
        return new ProperatiLamudiProjectPageStickyButtons(pageData);
    }
}